// https://alligator.io/react/i18n-with-react-and-i18next base tutorial

import i18next from 'i18next'

const en = require('./locales/en.json')
const de = require('./locales/de.json')

i18next.init({
  resources: {
    en,
    de
  },
  lng: 'en',
  fallbackLng: 'en',
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false
  }
})

export default i18next



// WEBPACK FOOTER //
// ./src/i18n/i18n.js